import { render, staticRenderFns } from "./SelectionForm.vue?vue&type=template&id=5051ab64"
import script from "./SelectionForm.vue?vue&type=script&lang=js"
export * from "./SelectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports